import { apiPatch } from "../baseApi";

export const restore = async (id) => {
  try {
    const response = await apiPatch("_district", id, '/restore' );
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
